import React from 'react';
import LocalizedStrings from 'react-localization';
import { toast, style, ToastContainer } from 'react-toastify';
import './Toaster.css'
import moment from 'moment'
import { Howl } from 'howler'

style({
  colorInfo: "#2c455a",
})

class Toaster extends React.Component {
  render() {
    return (
      <div className="toast-container">
        <ToastContainer className="view-toast-container" toastClassName="view-toast" closeButton={false} autoClose={10000}/>
      </div>
    )
  }
}

function emitToastForNotification(notification) {

  const strings = new LocalizedStrings({
   en:{
     signinHome: '{0} signed in at Home ',
     signin: '{0} signed in to {1} ',
     signout: '{0} signed out from {1} ',
     bookFrom: '{0} booked from {1} to {2} ',
     today: 'today ',
     on: 'on {0} ',
     requiredIn: '{0} is required in {1} ',
     beginIn: '{0} will begin in {1} in {2} '
   },
   de: {
     signinHome: '{0} zu Hause eingeloggt ',
     signin: '{0} ist in {1} eingeloggt ',
     signout: '{0} in {1} ausgeloggt ',
     bookFrom: '{0} heute von {1} bis {2} reserviert ',
     today: '',
     on: 'am ',
     requiredIn: '{0} Anwesenheit ist in {1} erforderlich ',
     beginIn: '{0} beginnt in {1} in {2} ',
   }
  });

  const notificationData = notification.notification;
  const notificationType = notification.type;

  if(notificationType === 'signin' && notificationData.location === "Home") {
    sendNotification(strings.formatString(strings.signinHome, notificationData.name))
  } else if(notificationType === 'signin') {
    sendNotification(strings.formatString(strings.signin, notificationData.name, notificationData.location))
  } else if(notificationType === 'signout') {
    sendNotification(strings.formatString(strings.signout, notificationData.name, notificationData.location))
  } else if(notificationType === "bookevent") {

    const startDate = notificationData.startDate;
    const date = moment().format('DD/MM/YYYY');

    if(startDate === date) {
      sendNotification(strings.formatString(strings.bookFrom, capitalize(notificationData.roomName), notificationData.startTime, notificationData.endTime) + strings.today)
    } else {
      sendNotification(strings.formatString(strings.bookFrom, capitalize(notificationData.roomName), notificationData.startTime, notificationData.endTime) + strings.formatString(strings.on, notificationData.startDate))
    }

  } else if(notificationType === 'employeepage') {
    sendNotification(strings.formatString(strings.requiredIn, notificationData.employeename, capitalize(notificationData.roomname)))
  } else if(notificationType === 'meetingStartNotification') {
    sendNotification(strings.formatString(strings.beginIn, notificationData.meetingname, notificationData.timeToStart, notificationData.roomname))
  }
}

function sendNotification(message) {
  const token = window.localStorage.getItem('jwt');

  if(token && token !== '') {
    toast.info(message)

    var sound = new Howl({
      src: ['media/notification.mp3','media/notification.ogg']
    });

    sound.play();
  }
}

function capitalize(input) {
  input = input.toLowerCase();
  return input.substring(0,1).toUpperCase()+input.substring(1);
}

export {Toaster, emitToastForNotification};



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/Toaster/Toaster.js